import type { TourConfig } from '../types';

export const companyDetailPageTour: TourConfig = {
  pageId: 'company-detail',
  pageName: 'Company Detail',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="company-header"]',
      title: 'Company Info',
      intro:
        'The header shows the company name, type, notes, and contact details. Use Edit or Delete to manage this record.',
      platform: 'both',
    },
    {
      element: '[data-tour="visit-tracking"]',
      title: 'Visit Tracking',
      intro:
        'Track in-person visits to this referral source. The traffic-light indicator shows how recently you visited. Log new visits with evidence photos.',
      platform: 'both',
    },
    {
      element: '[data-tour="contacts-section"]',
      title: 'Contacts',
      intro:
        'Manage individual contacts at this company. Add contacts and send partner portal invitations.',
      platform: 'both',
    },
    {
      element: '[data-tour="projects-section"]',
      title: 'Projects',
      intro:
        'View projects referred by this company. Filter by status or search by name. Revenue and commission info is shown for each project.',
      platform: 'both',
    },
    {
      element: '[data-tour="outbound-referrals"]',
      title: 'Outbound Referrals',
      intro:
        'Send referrals back to this company. Track the status of each outbound referral you have sent.',
      platform: 'both',
    },
  ],
};
